import React from 'react';
import PropTypes from 'prop-types';

// custom components
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardFooter from "components/Card/CardFooter.jsx";
import Position from 'components/Position';
import {useTranslation} from "react-i18next";
import DivCenter from "components/styled-components/DivCenter";

const GeofenceFieldAnswerView = ({answerData}) => {
  const { t, } = useTranslation('question-engine-module-answer');
  return (
    <Card>
      <CardBody>
        <DivCenter>
          <h4>{answerData.answer.GeofenceFieldAnswer}</h4>
        </DivCenter>
      </CardBody>
      <CardFooter>
        <Position left>
          <small>{`${t("question-engine-module-answer.view.field")} : ${
            answerData.questionLabel
          }`}</small>
        </Position>
        <Position right>
          <small>{`${t("question-engine-module-answer.view.keyField")} : ${
            answerData.key
          }`}</small>
        </Position>
      </CardFooter>
    </Card>
  );
};

GeofenceFieldAnswerView.propTypes = {

};

export default GeofenceFieldAnswerView;
